import { IS_DEV } from '@/const'

export function getBaseUrl() {
  if(IS_DEV){
    return process.env.VUE_APP_BASE_DEV_API
  } else {
    return process.env.VUE_APP_STATIC_BASE_URL
  }
}